function scrollToTop() {
    setTimeout(() => {
        window.scrollTo({ top: 0, behavior: 'auto' });
    }, 250);
    
    const thirdStep = document.querySelector("[data-process-step-id='CreateMotorQuoteProcess:Discount']");

    if(thirdStep) {
        scroll(0, 0);
    }
}

export { scrollToTop };